"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACInputText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var icons_1 = require("../constants/icons");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var ACInputText = function (props) {
    var handleChange = function (e) {
        if (props.onChange) {
            props.onChange(e.target.value);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, { theme: {
                    token: {
                        colorBgContainerDisabled: props.disabledColor || '',
                    },
                }, children: (0, jsx_runtime_1.jsx)(antd_1.Input, { id: props.id || '', placeholder: props.placeholder, allowClear: props.allowClear, ref: props.ref, value: props.value, suffix: props.suffix, autoComplete: "off", prefix: props.isSearch ? ((0, jsx_runtime_1.jsx)("div", { className: props.iconClassName, children: icons_1.icons[props.icon] })) : (props.prefix), size: props.size, type: props.type, disabled: props.disabled, status: props.required && props.errorText ? 'error' : '', className: "".concat('apx-ui_input__text', " ").concat((props === null || props === void 0 ? void 0 : props.color) || 'primary', " ").concat(props.className), onChange: function (e) {
                        handleChange(e);
                    } }) }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : ('')] }));
};
exports.ACInputText = ACInputText;
